var {AmpersandApp: productCatalogApp, AmpersandView} = require('catalog/libs');

var HPEConstants = require('../../../base/hpe.constants');

var template = require('../templates/hpe.productlist.filtergroup.template.tpl');
var FilterCollectionView = require('./hpe.productlist.filter.view');

/**
 * collection of filter groups view
  * view hierarchy: filterlist > facet collection > facet > filtergroup collection (this) > filter group > filter collection > filter
 */
var FilterGroupCollectionView = AmpersandView.extend({
    render: function(opts) {
        this.renderCollection(this.collection, function(options) {
            return new FilterGroupView(options);
        }, this.el, opts);
        return this;
    }
});

/**
 * filter group view
  * view hierarchy: filterlist > facet collection > facet > filtergroup collection > filter group (this) > filter collection > filter
 */
var FilterGroupView = AmpersandView.extend({
    template: template,
    bindings: {
        'model.facetLabel': {
            type: 'text',
            selector: '.filterlist-group-headline span'
        },
        'model.expanded': [
            {
                type: 'booleanClass',
                selector: '.filterlist-group-headline',
                name: 'collapsed',
                invert: true
            },
            {
                type: 'attribute',
                selector: '.filterlist-group-list',
                name: 'aria-expanded'
            }
        ],
        'model.domid': [
            {
                type: 'attribute',
                selector: '.filterlist-group-list',
                name: 'id'
            },
            {
                type: 'attribute',
                selector: '.filterlist-group-headline',
                name: 'aria-controls'
            }
        ],
        'model.hasActiveFilter': {
            type: 'booleanClass',
            selector: '.filterlist-group-headline',
            name: 'active'
        }
    },

    subviews: {
        filters: {
            selector: '.filterlist-group-list',
            waitFor: 'model.facetValues',
            prepareView: function(el) {
                return new FilterCollectionView({
                    el: el,
                    collection: this.model.facetValues,
                    parentId: this.model.facet_id
                });
            }
        }
    },

    events: {
        'click .filterlist-group-headline': 'toggleOpenClose'
    },

    /**
     * handle click open/close toggle clicks on group headline toggle
     * @param  {object} e event object
     */
    toggleOpenClose: function(e) {

        e.preventDefault();
        this.model.expanded = (!this.model.expanded);

        //broadcast event to indicate filter/sidebar area props/height change
        //pass expanded state for filterstate update
        productCatalogApp.trigger(HPEConstants.catalog.FILTER_COLLAPSE_CHANGE, {
            expanded: this.model.expanded,
            id: this.model.facet_id
        });
    }
});

module.exports = FilterGroupCollectionView;
